// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"61":"c519d180","535":"91c9bb96","894":"296337d3"}[chunkId] + ".css";
};